import React from 'react'
import { Button, ButtonBase, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { SelectedKit } from './ProductCard'
import { useFormikContext } from 'formik'
import { useRouter } from 'next/router'
import { MilliplexFormValues } from '../../../Milliplex'
import { getSelectedKitQueryString } from '@src/routes/Configurators/products/Milliplex/utils'
import CloseIcon from '@material-ui/icons/Close'

interface EditAndCloseButtonsProps {
  onClick(): void
  selectedKit?: SelectedKit
  isCloseButton?: boolean
  width?: string
  bgColor?: string
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    buttonAlignmentWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    editButtonStyle: {
      marginRight: theme.spacing(5),
    },
    deleteCloseIcon: {
      fontSize: theme.typography.pxToRem(22),
      cursor: 'pointer',
      fontWeight: theme.typography.fontWeightBold,
    },
  }
})

const EditAndCloseButtons: React.FC<EditAndCloseButtonsProps> = ({
  onClick,
  selectedKit,
  isCloseButton,
}) => {
  const classes = useStyles()
  const formik = useFormikContext<MilliplexFormValues>()
  const router = useRouter()

  const removeKit = () => {
    if (selectedKit) {
      const { [selectedKit.id]: _, ...restQuery } = formik.values.selectedKits
      formik.setFieldValue('selectedKits', restQuery)
      const urlString = getSelectedKitQueryString(restQuery)
      router.replace(
        {
          pathname: router.pathname,
          query: { ...router.query, selectedKits: urlString },
        },
        undefined,
        { shallow: true, scroll: false }
      )
    }
  }

  return (
    <div className={classes.buttonAlignmentWrapper}>
      <Button
        className={classes.editButtonStyle}
        data-testid="milliplex-design-and-price-button"
        id="milliplex-design-and-price-button"
        variant="outlined"
        color="primary"
        fullWidth
        onClick={onClick}
      >
        <FormattedMessage
          id="MILLIQSQ_STEP_FOUR_SUMMARY_EDIT_BUTTON"
          defaultMessage="Edit"
        />
      </Button>
      {isCloseButton ? (
        <ButtonBase onClick={removeKit}>
          <CloseIcon className={classes.deleteCloseIcon} />
        </ButtonBase>
      ) : (
        <></>
      )}
    </div>
  )
}
export default EditAndCloseButtons
